import { useNavigate, Outlet, useLocation } from "react-router-dom";
import MobilePatternHeader from "../components/MobilePatternHeader";
import Button from "../components/Button";

const StatisticalReportPage = ({ isMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Tổng quan", path: "/bao-cao-thong-ke/tong-quan" },
    { label: "Báo cáo dịch vụ", path: "/bao-cao-thong-ke/dich-vu" },
    { label: "Báo cáo hồ sơ", path: "/bao-cao-thong-ke/ho-so" },
    { label: "Báo cáo tài chính", path: "/bao-cao-thong-ke/tai-chinh" },
  ];

  return (
    <div className="h-full min-h-0 flex flex-col bg-gray-50 overflow-hidden">
      <MobilePatternHeader
        title="Báo cáo thống kê"
        onBack={() => navigate(-1)}
        className="md:hidden"
      />

      <div className="flex-1 min-h-0 flex flex-col gap-6 overflow-hidden">
        <div className="shrink-0 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
          <h1 className="hidden md:block text-2xl font-semibold text-gray-800">
            Báo cáo thống kê
          </h1>
        </div>

        <div className="shrink-0 w-full overflow-x-auto">
          <div className="flex min-w-max items-center gap-1 bg-white p-1 rounded-xl border border-gray-200 w-fit">
            {tabs.map((tab) => {
              const isActive =
                location.pathname === tab.path ||
                (tab.path === "/bao-cao-thong-ke/tong-quan" &&
                  location.pathname === "/bao-cao-thong-ke");
              return (
                <Button
                  key={tab.path}
                  onClick={() => navigate(tab.path)}
                  variant={isActive ? "primary" : "neutral"}
                >
                  {tab.label}
                </Button>
              );
            })}
          </div>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto pr-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default StatisticalReportPage;
